export default "__VITE_ASSET__D$4G5SNH__"